<template>
  <div class="vx-row">
    <div class="w-full">
      <center>
        <vs-button
          type="border"
          size="medium"
          icon-pack="feather"
          icon="icon-map"
          color="danger"
          class="mb-5 ml-3"
          @click="openGmaps()"
          > Buka di Google Maps
        </vs-button>
      </center>
    </div>
    <div class="w-full">
      <GmapMap
        :center="coordinate"
        :zoom="16"
        style="width: 100%; height:500px;"
      >
        <GmapMarker
          :position="coordinate"
          :clickable="true"
          :draggable="true"
          @click="center=coordinate"
        />
      </GmapMap>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    coordinate: {
      type: Object,
      default(){
        return {lat:-8.603794454696615, lng:115.17666547480198}
      }
    }
  },
  methods: {
    openGmaps(){
      let url = `http://www.google.com/maps/place/${this.coordinate.lat},${this.coordinate.lng}`;
      window.open(url);
    }
  }
};
</script>
